import { useQuery } from '@tanstack/react-query';
import { createContext, useCallback, useMemo } from 'react';
import { getUserPermissions } from '../features/menus/apiMenu';

const BY_PASS = 0;

const initialState = {
    permissions: [],
    isLoading: false,
    isByPass: false
};

export const PermissionsContext = createContext({
    ...initialState,
    canView: () => { },
    canUpdate: () => { },
    canDelete: () => { },
    getEmployeeId: () => { },
    getPermissions: () => { },
});


export const PermissionsProvider = ({ children }) => {
    const { data, isLoading } = useQuery({ queryKey: ["permissions"], queryFn: getUserPermissions })
    const isByPass = data?.pages?.length === BY_PASS

    const getEmployeeId = useCallback(
        () => data?.employee_uuid,
        [data],
    )

    const canView = useCallback(
        (name) => isByPass ? true : data?.pages?.find(page => page.name === name)?.permissions?.can_read,
        [data, isByPass],
    )

    const canUpdate = useCallback(
        (name) =>
            isByPass
                ? true
                : data?.pages?.find(page => page.name === name)?.permissions?.can_update ||
                data?.pages?.find(page => page.name === name)?.permissions?.can_write,
        [data, isByPass]
    );

    const canDelete = useCallback(
        (name) => isByPass ? true : data?.pages?.find(page => page.name === name)?.permissions?.can_delete,
        [data, isByPass],
    )

    const getPermissions = useCallback(
        (name) => data?.pages?.find(page => page.name === name),
        [data],
    )

    const memorizedValue = useMemo(() => ({
        permissions: data?.pages || [],
        isLoading,
        isByPass,
        canView,
        canUpdate,
        canDelete,
        getPermissions,
        getEmployeeId
    }), [data, isLoading, isByPass, canView, canUpdate, canDelete, getPermissions, getEmployeeId]);

    return (
        <PermissionsContext.Provider value={memorizedValue}>
            {children}
        </PermissionsContext.Provider>
    );
};